import React, { forwardRef, useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import { Circles } from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import FamilyTree from "../../../lib/@balkangraph/familytree.js";
import AddMemberFromTreeModal from "../../../modals/yourAssets/FT/AddMemberFromTreeModal";
import EditMemberModal from "../../../modals/yourAssets/FT/EditMemberModal";
import Typography from "@mui/material/Typography";
import {
  getFamilyTree,
  getTotalAuditTrials,
  updateAuditTrials,
} from "../../../services/yourAssets/FamilyTreeServices";

import { setFamilyMembersList } from "../../../utils/FTUtilities";
import { relationships } from "../../../constants/constants";
import { BASE_URL, FT_KEY, S3_URL, VERSION } from "../../../constants/ApiUrls";
import {
  getDateFromDateStamp,
  getKeyFromText,
  getTimeFromDateStamp,
  getUserIdFromLocalStorage,
  changeUpdateFormat,
} from "../../../utils/Utilities.js";
import ModifiedByToaster from "../../../common/ModifiedByToaster/index.js";
import TutorialWindow from "./TutorialsWindow.js";
import { useDispatch } from "react-redux/es/exports";
const FamilyChart = forwardRef((props, ref) => {
  const {
    zoomScale,
    handleParentRefresh,
    isTutorialEnable,
    showTutorial,
    setVisited,
    tutorialShow,
    handleTutorialShow,
    handleOtherTutorialShow,
  } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const state = useSelector((state) => state.currentLanguage);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });

  const [tutorialPositionRoot, setTutorialPositionRoot] = useState({
    top: 0,
    left: 0,
  });
  const [tutorialPositionMotherAdd, setTutorialPositionMotherAdd] = useState({
    top: 0,
    left: 0,
  });
  const [tutorialPositionMotherUpdate, setTutorialPositionMotherUpdate] =
    useState({ top: 0, left: 0 });
  const relationships = [
    { id: 1, name: t("relationship-1"), gender: "male" },
    { id: 2, name: t("relationship-2"), gender: "female" },
    { id: 3, name: t("relationship-3"), gender: "male" },
    { id: 4, name: t("relationship-4"), gender: "female" },
    { id: 5, name: t("relationship-5"), gender: "male" },
    { id: 6, name: t("relationship-6"), gender: "female" },
    { id: 7, name: t("relationship-7"), gender: "male" },
    { id: 8, name: t("relationship-8"), gender: "female" },
    { id: 9, name: t("relationship-9"), gender: "male" },
    { id: 10, name: t("relationship-10"), gender: "female" },
    { id: 11, name: t("relationship-11"), gender: "male" },
    { id: 12, name: t("relationship-12"), gender: "male" },
  ];
  const [complicatedRelation, setComplicatedRelation] = useState(false);
  const [addMemberModal, setAddMemberModal] = useState(false);
  const [editMemberModal, setEditMemberModal] = useState(false);
  const [currentNode, setCurrentNode] = useState({});
  const [refreshTree, setRefreshTree] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");
  const [membersList, setMembersList] = useState([]);
  const [auditTrialList, setAuditTrialList] = useState([]);

  const divRef = useRef();
  const motherAddReference = useRef(null);
  const rootReference = useRef(null);
  const motherUpdateReference = useRef(null);

  const htmlImageRef = useRef(null);
  const updateRootImageRef = useRef(null);

  const profileRootImageRef = useRef(null);

  const firstStepTutorialRef = useRef(null);

  ////testing purpose

  const lineRef = useRef(null);
  const p1Ref = useRef(null);
  const p2Ref = useRef(null);
  ////////////////
  const [showOverlay, setShowOverlay] = useState(true);

  const newUserTutorialInfoReference = useRef(null);
  const [newUserTutorialInfoShow, setNewUserTutorialInfoShow] = useState(false);
  const [newUserTutorialInfoMessage, setNewUserTutorialInfoMessage] =
    useState("");
  const [
    newUserTutorialInfoArrowPosition,
    setNewUserTutorialInfoArrowPosition,
  ] = useState("");
  const [newUserTutorialInfoCurrentStep, setNewUserTutorialInfoCurrentStep] =
    useState("");

  const [newUserTutorialInfoPosition, setNewUserTutorialInfoPosition] =
    useState({
      top: 0,
      left: 0,
    });

  let uID = getUserIdFromLocalStorage();
  let currentConsultantId = localStorage.getItem("currentConsultantId");
  const getTree = async () => {
    setLoading(true);
    try {
      let result = await getFamilyTree(uID);

      let result2 = await getTotalAuditTrials(
        currentConsultantId ? currentConsultantId : uID
      );
      if (result2.status === 204) {
      } else {
        result2 = result2.payLoad;
      }
      let changedObjects = [];
      for (let i = 0; i < result2.length; i++) {
        const elementI = result2[i];
        changedObjects.push(elementI.auditTrailId);

        for (let j = 0; j < result?.familyTree?.length; j++) {
          const elementJ = result?.familyTree[j];
          if (
            elementI.objectName === "UserFamilyTree" &&
            elementI.keyValues.ObjectId === elementJ.familyTreeId
          ) {
            elementJ.shadow = "/assets/icons/shadow.png";
            setAuditTrialList([...auditTrialList, elementI]);
          }
        }
      }
      if (changedObjects.length) {
        await updateAuditTrials(currentConsultantId, changedObjects);
      }

      for (let i = 0; i < result?.familyTree?.length; i++) {
        const element = result?.familyTree[i];
        if (
          element.id == 2 &&
          ["Father", "Vater"].includes(element.firstName)
        ) {
          element.firstName = t("relationship-5");
        }
        if (
          element.id == 3 &&
          ["Mother", "Mutter"].includes(element.firstName)
        ) {
          element.firstName = t("relationship-6");
        }
        if (element.gender === "other") {
          element.gender = "female";
        }
        if (
          element.relationship !== t("relationship-11") &&
          element.relationship !== t("relationship-12")
        ) {
          element.addNew = "/assets/icons/plus.png";
        }
        if (element.lastName === null) {
          element.lastName = "";
        }
        if (element.complicatedRelation && !element.isDead) {
          element.isAliveImage = "/assets/icons/bolt.png";
        } else if (element.isDead && !element.complicatedRelation) {
          element.isAliveImage = "/assets/icons/cross.png";
        } else if (element.complicatedRelation && element.isDead) {
          element.isAliveImage = "/assets/icons/cross.png";
        }
        if (
          element.firstName &&
          element.lastName &&
          element.dateOfBirth &&
          element.relationship !== t("relationship-11")
        ) {
          element.edit = "/assets/icons/tick.png";
        } else if (
          element.firstName &&
          element.dateOfBirth &&
          element.relationship === t("relationship-11")
        ) {
          element.edit = "/assets/icons/tick.png";
        } else {
          element.edit = "/assets/icons/edit.png";
        }

        if (!element.pictureId) {
          switch (element.relationship) {
            case "root":
              if (element.gender === "male") {
                element.profilePicture = "/assets/icons/you.png";
              } else {
                element.profilePicture = "/assets/icons/partner-female.png";
              }
              break;
            case "Partner-Male":
              element.profilePicture = "/assets/icons/partner-male.png";
              break;
            case "Partner-Female":
              element.profilePicture = "/assets/icons/partner-female.png";
              break;
            case "Ex-Partner-Male":
              element.profilePicture = "/assets/icons/ex-partner-male.png";
              break;
            case "Ex-Partner-Female":
              element.profilePicture = "/assets/icons/ex-partner-female.png";
              break;
            case "Father":
              element.profilePicture = "/assets/icons/parent-male.png";
              break;
            case "Mother":
              element.profilePicture = "/assets/icons/parent-female.png";
              break;
            case "Brother":
              element.profilePicture = "/assets/icons/sibling-male.png";
              break;
            case "Sister":
              element.profilePicture = "/assets/icons/sibling-female.png";
              break;
            case "Son":
              element.profilePicture = "/assets/icons/child-male.png";
              break;
            case "Daughter":
              element.profilePicture = "/assets/icons/child-female.png";
              break;

            default:
              break;
          }
        } else {
          element.profilePicture =
            BASE_URL +
            FT_KEY +
            VERSION +
            uID +
            "/familytree-image?familyTreeImageId=" +
            element.pictureId;
        }
      }

      setFamilyMembersList(result?.familyTree);
      result = result?.familyTree?.filter(
        (item) => item.relationship !== "Pet" && item.relationship !== "Friend"
      );
      let arr = [];
      result.forEach((member) => {
        arr = [
          ...arr,
          { ...member, relationship: t(getKeyFromText(member.relationship)) },
        ];
      });
      setMembersList(arr);

      const family = new FamilyTree(divRef.current, {
        //zoom:true,
        zoom: {
          smooth: isTutorialEnable ? 0 : 130,
          speed: isTutorialEnable ? 0 : 10,
        },
        toolbar: {
          zoom: false,
        },
        nodeMouseClick: FamilyTree.action.none,
        template: "myTemplate",
        enableSearch: false,
        nodeBinding: {
          field_0: "firstName",
          field_1: "lastName",
          field_2: "relationship",
          img_3: "shadow",
          photo: "profilePicture",
          img_1: "edit",
          img_4: "addNew",
          img_2: "isAliveImage",
          tutorial_window: "infoText",
        },

        nodes: arr,
        //showXScroll: true,
        //showYScroll: true,
        sticky: false,

        // mouseScrool: FamilyTree.action.zoom,
        scaleInitial: zoomScale,
      });

      family.onNodeClick((data) => {
        let clickedButton = data.event.srcElement.id;
        let node = data.node;
        let nodeElement = family.getNodeElement(node.id);
        let nodeData = family.get(node.id);

        let svgFile = family.getSvg();

        // export current state to HTML
        const data1 = new XMLSerializer().serializeToString(svgFile);
        // generate blob with base64 data of image
        const blob = new Blob([data1], { type: "image/svg+xml" });
        const URL = window.URL || window.webkitURL || window;
        const blobURL = URL.createObjectURL(blob);

        let reader = new FileReader();
        let base64data = "";
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          base64data = reader.result;
        };

        setCurrentNode(JSON.parse(JSON.stringify(nodeData)));
        let editIndex;
        let addIndex;
        let lastIndex = nodeElement.childNodes.length - 1;
        if (nodeData.gender === "male") {
          if ([8, 9].includes(lastIndex)) {
            editIndex = 7;
            addIndex = 8;
          } else if ([10, 11, 12].includes(lastIndex)) {
            editIndex = 10;
            addIndex = 11;
          } else if ([6].includes(lastIndex)) {
            editIndex = 5;
            addIndex = 6;
          }
        } else {
          if ([7, 8].includes(lastIndex)) {
            editIndex = 6;
            addIndex = 7;
          } else if ([9, 10, 11].includes(lastIndex)) {
            editIndex = 9;
            addIndex = 10;
          } else if ([5].includes(lastIndex)) {
            editIndex = 4;
            addIndex = 5;
          } else if ([6].includes(lastIndex)) {
            editIndex = 5;
            addIndex = 6;
          }
        }

        nodeElement.childNodes[editIndex].addEventListener("click", () =>
          handleClick(nodeData, "edit")
        );
        nodeElement.childNodes[addIndex].addEventListener("click", () =>
          handleClick(nodeData, "add")
        );
        if (clickedButton == "add") {
          nodeElement.childNodes[addIndex].dispatchEvent(new Event("click"));
        } else if (clickedButton == "edit") {
          nodeElement.childNodes[editIndex].dispatchEvent(new Event("click"));
        }
      });
      family.on("render-link", (sender, args) => {
        var cnodeData = family.get(args.cnode.id);
        var nodeData = family.get(args.node.id);
        args.html = args.html.replace("path", "path stroke-dasharray='4, 4'");
      });

      FamilyTree.templates.myTemplate = Object.assign(
        {},
        FamilyTree.templates.tommy
      );
      FamilyTree.templates.myTemplate.size = [200, 200];

      FamilyTree.templates.myTemplate.defs = ``;

      FamilyTree.templates.myTemplate.photo =
        `<defs>
  <rect id="rect1"  x="60" y="30" width="80" height="80" rx="50%"/>
    <clipPath id="clip1">
      <use xlink:href="#rect1"/>
    </clipPath>
    </defs><image  preserveAspectRatio="xMidYMid slice" clip-path="url(#clip1)" xlink:href="{val}"  x="60" y="30" width="80" height="80">` +
        "</image>";

      FamilyTree.templates.myTemplate.img_1 =
        `<image id="edit"  preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="120" y="90" width="20" height="20">` +
        "</image>";
      FamilyTree.templates.myTemplate.img_2 =
        '<image preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="60" y="28" width="20" height="20">' +
        "</image>";

      FamilyTree.templates.myTemplate.img_4 =
        '<image id="add" preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="120" y="28" width="20" height="20">' +
        "</image>";

      FamilyTree.templates.myTemplate.img_3 =
        `<defs>
  <rect id="rect"  x="10" y="2" width="250" height="250" rx="1%"/>
    <clipPath id="clip">
      <use xlink:href="#rect"/>
    </clipPath>
    </defs>
    <image id="1222" preserveAspectRatio="xMidYMid slice" clip-path="url(#clip)" xlink:href="{val}"  x="-25" y="-45" width="250" height="250" >` +
        "</image>";

      FamilyTree.templates.myTemplate.field_0 =
        '<text style="font-size: 12px;" fill="#000" x="100" y="130" text-anchor="middle">{val}</text>';

      FamilyTree.templates.myTemplate.field_1 =
        '<text style="font-size: 10px;" fill="#000" x="100" y="150" text-anchor="middle">{val}</text>';
      FamilyTree.templates.myTemplate.field_2 =
        '<text style="font-size: 10px;" fill="#000" x="100" y="20" text-anchor="middle">{val}</text>';

      FamilyTree.templates.myTemplate_male = Object.assign(
        {},
        FamilyTree.templates.myTemplate
      );

      FamilyTree.templates.myTemplate_female = Object.assign(
        {},
        FamilyTree.templates.myTemplate
      );

      FamilyTree.templates.myTemplate_male.node = `<circle cx="100" cy="100" r="0" fill="transparent" stroke-width="1" stroke="transparent"></circle> `;

      FamilyTree.templates.myTemplate_female.node =
        '<circle cx="100" cy="100" r="0" fill="transparent" stroke-width="1" stroke="transparent"></circle>';

      FamilyTree.templates.myTemplate.link =
        '<path stroke="#123123" stroke-width="1px" fill="#182931" data-l-id="[{id}][{child-id}]" d="M{xa},{ya} C{xb},{yb} {xc},{yc} {xd},{yd}" />';

      setRefreshTree(false);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = (idenifier) => {
    if (Number(idenifier) === 1)
      handleTutorialShow({ ...tutorialShow, root: false });
    if (Number(idenifier) === 2)
      handleTutorialShow({ ...tutorialShow, edit: false });
    if (Number(idenifier) === 3)
      handleTutorialShow({ ...tutorialShow, add: false });
    setIsModalOpen(false);
  };
  const handleFirstVisitTutorial = async (step) => {
    const rootNode = document.querySelector('[data-n-id="1"]');
    const motherNode = document.querySelector('[data-n-id="3"]');

    let rootAddImagePosition = rootNode.querySelectorAll("image")[2];
    let motherAddImagePosition = motherNode.querySelectorAll("image")[2];
    let motherUpdateImagePosition = motherNode.querySelectorAll("image")[1];
    let rootUpdateImagePosition = rootNode.querySelectorAll("image")[1];
    let rootProfileImagePosition = rootNode.querySelectorAll("image")[0];
    let motherProfileImagePosition = motherNode.querySelectorAll("image")[0];

    const htmlImageElement = htmlImageRef.current;
    const rootUpdateImageElement = updateRootImageRef.current;
    const rootProfileImageElement = profileRootImageRef.current;
    const otherElement = ref.current;

    if (
      rootAddImagePosition &&
      rootUpdateImagePosition &&
      rootProfileImagePosition
    ) {
      let svgPos;
      let targetImagePos;
      let targetRootUpdateImagePos;
      let targetRootProfileImagePos;
      if (step == 0) {
        svgPos = rootNode.getBoundingClientRect();
        targetImagePos = rootAddImagePosition.getBoundingClientRect();
        targetRootUpdateImagePos =
          rootUpdateImagePosition.getBoundingClientRect();
        targetRootProfileImagePos =
          rootProfileImagePosition.getBoundingClientRect();

        //setNewUserTutorialInfoMessage("ft-tutorials.root");
        //setNewUserTutorialInfoArrowPosition("left-top");
        //setNewUserTutorialInfoCurrentStep("1");
      } else if (step == 1) {
        svgPos = rootNode.getBoundingClientRect();
        targetImagePos = rootAddImagePosition.getBoundingClientRect();
        targetRootUpdateImagePos =
          rootUpdateImagePosition.getBoundingClientRect();
        targetRootProfileImagePos =
          rootProfileImagePosition.getBoundingClientRect();

        setNewUserTutorialInfoMessage("ft-tutorials.root");
        setNewUserTutorialInfoArrowPosition("left-top");
        setNewUserTutorialInfoCurrentStep("1");
      } else if (step == 2) {
        svgPos = motherNode.getBoundingClientRect();
        targetImagePos = motherAddImagePosition.getBoundingClientRect();
        targetRootUpdateImagePos =
          motherUpdateImagePosition.getBoundingClientRect();
        targetRootProfileImagePos =
          motherProfileImagePosition.getBoundingClientRect();

        setNewUserTutorialInfoMessage("ft-tutorials.mother-add");
        setNewUserTutorialInfoArrowPosition("left-top");
        setNewUserTutorialInfoCurrentStep("2");
      } else if (step == 3) {
        svgPos = motherNode.getBoundingClientRect();
        targetImagePos = motherAddImagePosition.getBoundingClientRect();
        targetRootUpdateImagePos =
          motherUpdateImagePosition.getBoundingClientRect();
        targetRootProfileImagePos =
          motherProfileImagePosition.getBoundingClientRect();

        setNewUserTutorialInfoMessage("ft-tutorials.mother-update");
        setNewUserTutorialInfoArrowPosition("left-top");
        setNewUserTutorialInfoCurrentStep("3");
      } else if (step == 4) {
        setNewUserTutorialInfoMessage("ft-tutorials.other");
        setNewUserTutorialInfoArrowPosition("right-top");
        setNewUserTutorialInfoCurrentStep("4");
      }

      if (step != 4) {
        const htmlImageWidth = targetImagePos.width;
        const htmlImageHeight = targetImagePos.height;
        const htmlImageLeft = targetImagePos.left + window.pageXOffset;
        const htmlImageTop = targetImagePos.top + window.pageYOffset;
        htmlImageElement.style.width = `${htmlImageWidth}px`;
        htmlImageElement.style.height = `${htmlImageHeight}px`;
        htmlImageElement.style.left = `${htmlImageLeft}px`;
        htmlImageElement.style.top = `${htmlImageTop}px`;
        htmlImageElement.style.display = `block`;

        const htmlRootUpdateImageWidth = targetRootUpdateImagePos.width;
        const htmlRootUpdateImageHeight = targetRootUpdateImagePos.height;
        const htmlRootUpdateImageLeft =
          targetRootUpdateImagePos.left + window.pageXOffset;
        const htmlRootUpdateImageTop =
          targetRootUpdateImagePos.top + window.pageYOffset;

        rootUpdateImageElement.style.width = `${htmlRootUpdateImageWidth}px`;
        rootUpdateImageElement.style.height = `${htmlRootUpdateImageHeight}px`;
        rootUpdateImageElement.style.left = `${htmlRootUpdateImageLeft}px`;
        rootUpdateImageElement.style.top = `${htmlRootUpdateImageTop}px`;
        rootUpdateImageElement.style.display = `block`;
        if (step == 0) {
          htmlImageElement.style.width = `${htmlImageWidth + 20}px`;
          htmlImageElement.style.height = `${htmlImageHeight + 20}px`;
          htmlImageElement.src = `/assets/icons/ft-tutorisal-icons/step-1-add.png`;
          htmlImageElement.style.top = `${htmlImageTop - 10}px`;

          rootUpdateImageElement.style.width = `${
            htmlRootUpdateImageWidth + 20
          }px`;
          rootUpdateImageElement.style.height = `${
            htmlRootUpdateImageWidth + 20
          }px`;
          rootUpdateImageElement.src = `/assets/icons/ft-tutorisal-icons/step-1-update.png`;
          rootUpdateImageElement.style.top = `${htmlRootUpdateImageTop - 10}px`;
        } else {
          htmlImageElement.src = `/assets/icons/ft-tutorisal-icons/add-overlay.png`;
          rootUpdateImageElement.src = `/assets/icons/ft-tutorisal-icons/update-overlay.png`;
        }

        if (step != 0) {
          const htmlRootProfileImageWidth = targetRootProfileImagePos.width;
          const htmlRootProfileImageHeight = targetRootProfileImagePos.height;
          const htmlRootProfileImageLeft =
            targetRootProfileImagePos.left + window.pageXOffset;
          const htmlRootProfileImageTop =
            targetRootProfileImagePos.top + window.pageYOffset;
          rootProfileImageElement.style.width = `${htmlRootProfileImageWidth}px`;
          rootProfileImageElement.style.height = `${htmlRootProfileImageHeight}px`;
          rootProfileImageElement.style.left = `${htmlRootProfileImageLeft}px`;
          rootProfileImageElement.style.top = `${htmlRootProfileImageTop}px`;
          rootProfileImageElement.style.display = `block`;

          if (step > 1) {
            rootProfileImageElement.src = `/assets/icons/ft-tutorisal-icons/mother-overlay.png`;
          }
        }
      } else {
        profileRootImageRef.current.style.display = "none";
        updateRootImageRef.current.style.display = "none";
        htmlImageRef.current.style.display = "none";
        otherElement.style.zIndex = "1";
      }
    }
    if (step == 0) {
      firstStepTutorialRef.current.style.top =
        rootAddImagePosition.getBoundingClientRect().top - 100 + "px";
      firstStepTutorialRef.current.style.left =
        rootAddImagePosition.getBoundingClientRect().left + 120 + "px";
      firstStepTutorialRef.current.style.display = "block";

      const svgRect = rootAddImagePosition.getBoundingClientRect();
      const svgRectUpdate = rootUpdateImagePosition.getBoundingClientRect();
      const divRect = firstStepTutorialRef.current.getBoundingClientRect();

      const p1Rect = p1Ref.current.getBoundingClientRect(); // Get the rect for the first <p> tag

      const svgX = svgRect.left + svgRect.width / 2;
      const svgY = svgRect.top + svgRect.height / 2;
      const p1X = p1Rect.left; // Calculate the center X coordinate of the first <p> tag
      const p1Y = p1Rect.top + p1Rect.height / 2; // Calculate the center Y coordinate of the first <p> tag
      //const p2X = p2Rect.left + p2Rect.width / 2; // Calculate the center X coordinate of the second <p> tag
      //const p2Y = p2Rect.top + p2Rect.height / 2; // Calculate the center Y coordinate of the second <p> tag

      const line = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "line"
      );
      line.setAttribute("x1", svgX);
      line.setAttribute("y1", svgY);
      line.setAttribute("x2", p1X);
      line.setAttribute("y2", p1Y);
      lineRef.current.appendChild(line);

      const p2Rect = p2Ref.current.getBoundingClientRect(); // Get the rect for the second <p> tag
      const svgUpdateX = svgRectUpdate.left + svgRectUpdate.width / 2;
      const svgUpdateY = svgRectUpdate.top + svgRectUpdate.height / 2;
      const p2X = p2Rect.left; // Calculate the center X coordinate of the second <p> tag
      const p2Y = p2Rect.top + p2Rect.height / 2; // Calculate the center Y coordinate of the second <p> tag

      const line2 = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "line"
      );
      line2.setAttribute("x1", svgUpdateX);
      line2.setAttribute("y1", svgUpdateY);
      line2.setAttribute("x2", p2X);
      line2.setAttribute("y2", p2Y);

      lineRef.current.appendChild(line2);
    } else if (step == 1) {
      setNewUserTutorialInfoPosition({
        top: rootAddImagePosition.getBoundingClientRect().top - 13 + "px",
        left: rootAddImagePosition.getBoundingClientRect().left + 50 + "px",
      });
    } else if (step == 2) {
      setNewUserTutorialInfoPosition({
        top: motherAddImagePosition.getBoundingClientRect().top - 13 + "px",
        left: motherAddImagePosition.getBoundingClientRect().left + 50 + "px",
      });
    } else if (step == 3) {
      setNewUserTutorialInfoPosition({
        top: motherUpdateImagePosition.getBoundingClientRect().top - 10 + "px",
        left:
          motherUpdateImagePosition.getBoundingClientRect().left + 50 + "px",
      });
    } else if (step == 4) {
      setNewUserTutorialInfoPosition({
        top: otherElement.getBoundingClientRect().top - 55 + "px",
        left: otherElement.getBoundingClientRect().left - 420 + "px",
      });
    }
    if (step != 0) {
      setNewUserTutorialInfoShow(true);
    }
  };
  const handleTutorialSteps = async (currentStep) => {
    if (currentStep == 0) {
      firstStepTutorialRef.current.style.display = "none";
      lineRef.current.style.display = "none";
      handleFirstVisitTutorial(parseInt(currentStep) + 1);
    } else if (currentStep == 4) {
      dispatch(setVisited(showTutorial.id));
      setNewUserTutorialInfoShow(false);
      setShowOverlay(false);
    } else {
      handleFirstVisitTutorial(parseInt(currentStep) + 1);
    }
  };
  const handleTutorialSkip = async (currentStep) => {
    dispatch(setVisited(showTutorial.id));
    setNewUserTutorialInfoShow(false);
    setShowOverlay(false);
  };

  useEffect(() => {
    if (showTutorial?.status == false) {
      setTimeout(() => {
        //setShowOverlay(true);
        handleFirstVisitTutorial(0);
      }, 3000);
    } else if (showTutorial?.status == true) {
      setShowOverlay(false);
    }
  }, [showTutorial]);
  useEffect(() => {
    if (isTutorialEnable) {
      const rootNode = document.querySelector('[data-n-id="1"]');
      const motherNode = document.querySelector('[data-n-id="3"]');

      let rootAddImagePosition = rootNode.querySelectorAll("image")[2];
      let motherAddImagePosition = motherNode.querySelectorAll("image")[2];
      let motherUpdateImagePosition = motherNode.querySelectorAll("image")[1];

      setTutorialPositionRoot({
        top: rootAddImagePosition.getBoundingClientRect().top - 15 + "px",
        left: rootAddImagePosition.getBoundingClientRect().left + 35 + "px",
      });

      const div2Element = motherAddReference.current;

      setTutorialPositionMotherAdd({
        top:
          motherAddImagePosition.getBoundingClientRect().top -
          (div2Element.offsetHeight + 15) +
          "px",
        left:
          motherAddImagePosition.getBoundingClientRect().left -
          div2Element.offsetWidth +
          35 +
          "px",
      });
      setTutorialPositionMotherUpdate({
        top: motherUpdateImagePosition.getBoundingClientRect().top - 15 + "px",
        left:
          motherUpdateImagePosition.getBoundingClientRect().left + 35 + "px",
      });

      let obj = {};
      Object.keys(tutorialShow).forEach((key) => {
        obj = { ...obj, [key]: true };
      });
      handleTutorialShow({ ...obj });
    } else {
      let obj = {};
      Object.keys(tutorialShow).forEach((key) => {
        obj = { ...obj, [key]: false };
      });
      handleTutorialShow({ ...obj });
    }
  }, [isTutorialEnable]);
  useEffect(() => {
    getTree();
  }, [state]);

  useEffect(() => {
    if (refreshTree) getTree();
  }, [refreshTree]);

  useEffect(() => {
    const getTreeForZoom = async () => {
      const family = new FamilyTree(divRef.current, {
        zoom: {
          smooth: isTutorialEnable ? 0 : 130,
          speed: isTutorialEnable ? 0 : 10,
        },

        //zoom:true,
        toolbar: {
          zoom: false,
        },
        nodeMouseClick: FamilyTree.action.none,
        template: "myTemplate",
        enableSearch: false,
        nodeBinding: {
          field_0: "firstName",
          field_1: "lastName",
          field_2: "relationship",
          img_3: "shadow",
          photo: "profilePicture",
          img_1: "edit",
          img_4: "addNew",
          img_2: "isAliveImage",
          tutorial_window: "infoText",
        },

        nodes: membersList,
        //showXScroll: true,
        //showYScroll: true,
        sticky: false,

        //mouseScrool: FamilyTree.action.zoom,
        scaleInitial: zoomScale,
      });
      family.onNodeClick((data) => {
        let clickedButton = data.event.srcElement.id;
        let node = data.node;
        let nodeElement = family.getNodeElement(node.id);
        let nodeData = family.get(node.id);

        let svgFile = family.getSvg();

        // export current state to HTML
        const data1 = new XMLSerializer().serializeToString(svgFile);
        // generate blob with base64 data of image
        const blob = new Blob([data1], { type: "image/svg+xml" });
        const URL = window.URL || window.webkitURL || window;
        const blobURL = URL.createObjectURL(blob);

        let reader = new FileReader();
        let base64data = "";
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          base64data = reader.result;
        };

        setCurrentNode(JSON.parse(JSON.stringify(nodeData)));
        let editIndex;
        let addIndex;
        let lastIndex = nodeElement.childNodes.length - 1;
        if (nodeData.gender === "male") {
          if ([8, 9].includes(lastIndex)) {
            editIndex = 7;
            addIndex = 8;
          } else if ([10, 11, 12].includes(lastIndex)) {
            editIndex = 10;
            addIndex = 11;
          } else if ([6].includes(lastIndex)) {
            editIndex = 5;
            addIndex = 6;
          }
        } else {
          if ([7, 8].includes(lastIndex)) {
            editIndex = 6;
            addIndex = 7;
          } else if ([9, 10, 11].includes(lastIndex)) {
            editIndex = 9;
            addIndex = 10;
          } else if ([5].includes(lastIndex)) {
            editIndex = 4;
            addIndex = 5;
          } else if ([6].includes(lastIndex)) {
            editIndex = 5;
            addIndex = 6;
          }
        }

        nodeElement.childNodes[editIndex].addEventListener("click", () =>
          handleClick(nodeData, "edit")
        );
        nodeElement.childNodes[addIndex].addEventListener("click", () =>
          handleClick(nodeData, "add")
        );
        if (clickedButton == "add") {
          nodeElement.childNodes[addIndex].dispatchEvent(new Event("click"));
        } else if (clickedButton == "edit") {
          nodeElement.childNodes[editIndex].dispatchEvent(new Event("click"));
        }
      });
      family.on("render-link", (sender, args) => {
        var cnodeData = family.get(args.cnode.id);
        var nodeData = family.get(args.node.id);
        args.html = args.html.replace("path", "path stroke-dasharray='4, 4'");
      });

      FamilyTree.templates.myTemplate = Object.assign(
        {},
        FamilyTree.templates.tommy
      );
      FamilyTree.templates.myTemplate.size = [200, 200];

      FamilyTree.templates.myTemplate.defs = ``;

      FamilyTree.templates.myTemplate.photo =
        `<defs>
  <rect id="rect1"  x="60" y="30" width="80" height="80" rx="50%"/>
    <clipPath id="clip1">
      <use xlink:href="#rect1"/>
    </clipPath>
    </defs><image  preserveAspectRatio="xMidYMid slice" clip-path="url(#clip1)" xlink:href="{val}"  x="60" y="30" width="80" height="80">` +
        "</image>";

      FamilyTree.templates.myTemplate.img_1 =
        `<image id="edit"  preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="120" y="90" width="20" height="20">` +
        "</image>";
      FamilyTree.templates.myTemplate.img_2 =
        '<image preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="60" y="28" width="20" height="20">' +
        "</image>";

      FamilyTree.templates.myTemplate.img_4 =
        '<image id="add" preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="120" y="28" width="20" height="20">' +
        "</image>";

      FamilyTree.templates.myTemplate.img_3 =
        `<defs>
  <rect id="rect"  x="10" y="2" width="250" height="250" rx="1%"/>
    <clipPath id="clip">
      <use xlink:href="#rect"/>
    </clipPath>
    </defs>
    <image id="1222" preserveAspectRatio="xMidYMid slice" clip-path="url(#clip)" xlink:href="{val}"  x="-25" y="-45" width="250" height="250" >` +
        "</image>";

      FamilyTree.templates.myTemplate.field_0 =
        '<text style="font-size: 12px;" fill="#000" x="100" y="130" text-anchor="middle">{val}</text>';

      FamilyTree.templates.myTemplate.field_1 =
        '<text style="font-size: 10px;" fill="#000" x="100" y="150" text-anchor="middle">{val}</text>';
      FamilyTree.templates.myTemplate.field_2 =
        '<text style="font-size: 10px;" fill="#000" x="100" y="20" text-anchor="middle">{val}</text>';

      FamilyTree.templates.myTemplate_male = Object.assign(
        {},
        FamilyTree.templates.myTemplate
      );

      FamilyTree.templates.myTemplate_female = Object.assign(
        {},
        FamilyTree.templates.myTemplate
      );

      FamilyTree.templates.myTemplate_male.node = `<circle cx="100" cy="100" r="0" fill="transparent" stroke-width="1" stroke="transparent"></circle> `;

      FamilyTree.templates.myTemplate_female.node =
        '<circle cx="100" cy="100" r="0" fill="transparent" stroke-width="1" stroke="transparent"></circle>';

      FamilyTree.templates.myTemplate.link =
        '<path stroke="#123123" stroke-width="1px" fill="#182931" data-l-id="[{id}][{child-id}]" d="M{xa},{ya} C{xb},{yb} {xc},{yc} {xd},{yd}" />';
    };
    if (zoomScale < 1 || zoomScale > 1) getTreeForZoom();
  }, [zoomScale]);
  const handleClick = (item, key) => {
    if (key === "edit") {
      setEditMemberModal(true);
      handleOtherTutorialShow(false);
      handleTutorialShow({ ...tutorialShow, root: false });
      for (let i = 0; i < relationships.length; i++) {
        const element = relationships[i];
        if (element.name === item.relationship) {
          setDefaultValue(element);
        }
      }
    } else if (key === "add") {
      setAddMemberModal(true);
      handleOtherTutorialShow(false);
      handleTutorialShow({ ...tutorialShow, root: false });
    }
  };

  const refreshFamilyTree = () => {
    setRefreshTree(true);
    handleParentRefresh();
  };

  return (
    <>
      <Box
        component="div"
        className="family-chart"
        sx={{ position: "relative", height: "100%" }}
      >
        <div
          id="tree"
          ref={divRef}
          style={{
            visibility: loading ? "hidden" : "visible",
          }}
        ></div>
        {loading && (
          <div className="loader">
            <Circles color="#dfc8db" height={80} width={80} />
          </div>
        )}
      </Box>
      {addMemberModal && (
        <AddMemberFromTreeModal
          open={addMemberModal}
          handleClose={() => {
            setAddMemberModal(false);
            setComplicatedRelation(false);
          }}
          handleComplicatedRelation={() => {
            setComplicatedRelation(!complicatedRelation);
          }}
          complicatedRelation={complicatedRelation}
          currentNode={currentNode}
          defaultValue={defaultValue}
          refresh={refreshFamilyTree}
          userId={uID}
        />
      )}

      {editMemberModal && (
        <EditMemberModal
          open={editMemberModal}
          handleClose={() => {
            setEditMemberModal(false);
          }}
          defaultValue={defaultValue}
          currentNode={currentNode}
          refresh={refreshFamilyTree}
          enableSelection={true}
          userId={uID}
        />
      )}
      {auditTrialList?.length > 0 && (
        <ModifiedByToaster
          title={`${t("modified-by")} ${auditTrialList[0]?.username}` || ""}
          subTitle={` ${changeUpdateFormat(
            auditTrialList[0]?.updatedTime,
            i18n.language
          )}`}
        />
      )}
      <TutorialWindow
        screenId="root-info"
        reference={rootReference}
        open={tutorialShow.root}
        onClose={handleCloseModal}
        modalPosition={tutorialPositionRoot}
        message={t("ft-tutorials.root")}
        currentStep="1"
        arrowPosition="left-top"
      />
      <TutorialWindow
        screenId="mother-add-info"
        reference={motherAddReference}
        open={tutorialShow.add}
        onClose={handleCloseModal}
        modalPosition={tutorialPositionMotherAdd}
        message={t("ft-tutorials.mother-add")}
        currentStep="3"
        arrowPosition="bottom-right"
      />
      <TutorialWindow
        screenId="mother-update-info"
        reference={motherUpdateReference}
        open={tutorialShow.edit}
        onClose={handleCloseModal}
        modalPosition={tutorialPositionMotherUpdate}
        message={t("ft-tutorials.mother-update")}
        currentStep="2"
        arrowPosition="left-top"
      />
      {/* <img
        ref={htmlImageRef}
        src="/assets/icons/bolt.png"
        alt="HTML Image"
        style={{ position: "absolute", display: "none", zIndex: "9999999" }}
      /> */}
      {showOverlay && (
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.75)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: "1",
          }}
        >
          <img
            ref={htmlImageRef}
            src="/assets/icons/ft-tutorisal-icons/add-overlay.png"
            alt="HTML Image"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              display: "none",
            }}
          />

          <img
            ref={updateRootImageRef}
            src="/assets/icons/ft-tutorisal-icons/update-overlay.png"
            alt="HTML Image"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              display: "none",
            }}
          />

          <img
            ref={profileRootImageRef}
            src="/assets/icons/ft-tutorisal-icons/root-overlay.png"
            alt="HTML Image"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              display: "none",
            }}
          />
          <div
            ref={firstStepTutorialRef}
            style={{
              position: "absolute",
              display: "none",
            }}
          >
            <p
              ref={p1Ref}
              style={{ color: "white", marginBottom: "1.5rem", width: "360px" }}
            >
              {t("ft-tutorials.root-add")}
            </p>
            <p ref={p2Ref} style={{ color: "white", width: "360px" }}>
              {t("ft-tutorials.root-update")}
            </p>
            <button
              onClick={() => {
                handleTutorialSteps(0);
              }}
              style={{
                backgroundColor: "transparent",
                borderRadius: "10px",
                border: "2px solid #fff",
                padding: "10px 3rem",
                color: "#fff",
                marginTop: "1rem",
              }}
            >
              {t("ft-tutorials.got-it-button")}
            </button>
          </div>
          <TutorialWindow
            screenId=""
            reference={newUserTutorialInfoReference}
            open={newUserTutorialInfoShow}
            onClose={handleTutorialSteps}
            modalPosition={newUserTutorialInfoPosition}
            message={t(newUserTutorialInfoMessage)}
            currentStep={newUserTutorialInfoCurrentStep}
            arrowPosition={newUserTutorialInfoArrowPosition}
            backgroundColor="white"
            textColor="black"
            onSkip={handleTutorialSkip}
            skipButtonShow={true}
            sx={{
              "&:before": {
                [newUserTutorialInfoArrowPosition.includes("left")
                  ? "borderRight"
                  : "borderLeft"]: "11px solid #fff",
              },
            }}
          />
        </div>
      )}
      <svg ref={lineRef} className="line-container"></svg>
    </>
  );
});

export default FamilyChart;
